import api from './api';

async function getAdminVacancyAPI(mode: 'compact' | 'normal', group: string, searchValue: string, division?: string) {
  const response = await api.get(
    `admin_vacancy/?mode=${mode}${group
      ? `&group=${group}` : ''}${searchValue
      ? `&search=${searchValue}` : ''}${division
      ? `&division=${division}` : ''}&ownVacancies=false`,
  );
  return response?.data;
}

export default getAdminVacancyAPI;
